import { render, staticRenderFns } from "./ProjectShareFilesModal.vue?vue&type=template&id=67a69940&scoped=true"
import script from "./ProjectShareFilesModal.vue?vue&type=script&lang=js"
export * from "./ProjectShareFilesModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectShareFilesModal.vue?vue&type=style&index=0&id=67a69940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a69940",
  null
  
)

export default component.exports